<template>
<div class="chapter">
<div class="inner_page">
<div class="ipadfp"><img alt="The Little Book of Self-Care for Pisces: Simple Ways to Refresh and Restore—According to the Stars, by Constance Stellas." class="imagefp" src="images/9781507209875.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?c9ea6e12